import { Routes, Route } from "react-router-dom";
import Wrapper from "../components/Wrapper";
import Index from "../pages/Index";
import NoPage from "../pages/NoPage";
import Terms from "../pages/Terms";
import Privacy from "../pages/Privacy";
import PaymentSuccess from "../pages/PaymentSuccessful";
import PaymentFail from "../pages/PaymentFailed";
import Loading from "../components/home/Loading";
import Error from "../components/home/Error";
import { useLandingData } from "../hooks/useLandingData";
import ProductsPage from "../pages/ProductsPage";
import ProductDetails from "../pages/ProductDetails";

export default function App() {
  const { data, isLoading, error } = useLandingData();

  if (isLoading) return <Loading />;
  if (error) return <Error error={error.message} />;

  const { indexPageData, terms, privacy } = data;

  return (
    <Routes>
      <Route path="/" element={<Wrapper data={indexPageData} />}>
        <Route index element={<Index data={indexPageData} />} />
        <Route
          path="terms"
          element={<Terms footer={indexPageData.footer} data={terms} />}
        />
        <Route path="products" element={<ProductsPage />} />
        <Route path="product/:id/details" element={<ProductDetails />} />
        <Route
          path="privacy"
          element={<Privacy footer={indexPageData.footer} data={privacy} />}
        />
        <Route path="*" element={<NoPage />} />
      </Route>

      <Route path="payment">
        <Route path="success" element={<PaymentSuccess />} />
        <Route path="fail" element={<PaymentFail />} />
      </Route>
      <Route path="*" element={<NoPage />} />
    </Routes>
  );
}
